module.exports = __webpack_public_path__ + "img/how-to-start-playing.9f9371e6.jpg";